import { useContext } from 'react';
import { AppContext } from "../context";
import { IUser } from '../globals/interfaces';

export default function useUser () {
    const { user: _user } = useContext(AppContext);
    const user: IUser = _user;
    return {
        user
    }
}